export default "__VITE_ASSET__BkITVJMg__"